import { render, staticRenderFns } from "./LoadingPlaceholder.vue?vue&type=template&id=a3fea26e&scoped=true"
import script from "./LoadingPlaceholder.vue?vue&type=script&lang=js"
export * from "./LoadingPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./LoadingPlaceholder.vue?vue&type=style&index=0&id=a3fea26e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fea26e",
  null
  
)

export default component.exports